export default "__VITE_ASSET__DV4s8KHp__"